import React, { useMemo } from 'react';
import { DemeterGeography, TimeFrame } from '../../../../Generated/Raven-Demeter';
import styles from './NewsComponents.module.scss';
import { ArticleWithRating } from './NewsDefinitions';

interface ISegmentData {
    label: string;
    count: number;
    className: string;
}

const buildSegments = (counts: ISegmentData[]): ISegmentData[] => counts.filter((s) => s.count > 0);

interface IImpactBarsProps {
    pairs: ArticleWithRating[];
}

const ImpactBars: React.FC<IImpactBarsProps> = (props) => {
    const total = props.pairs.length;

    const geoSegments = useMemo(() => {
        const local = props.pairs.filter((p) => p.rating.geography === DemeterGeography.Local).length;
        const regional = props.pairs.filter((p) => p.rating.geography === DemeterGeography.Regional).length;
        const global = props.pairs.filter((p) => p.rating.geography === DemeterGeography.Global).length;
        return buildSegments([
            { label: 'Local', count: local, className: styles.bar_geo_local },
            { label: 'Regional', count: regional, className: styles.bar_geo_regional },
            { label: 'Global', count: global, className: styles.bar_geo_global },
        ]);
    }, [props.pairs]);

    const timeSegments = useMemo(() => {
        const short = props.pairs.filter((p) => p.rating.timeFrame === TimeFrame.Short).length;
        const medium = props.pairs.filter((p) => p.rating.timeFrame === TimeFrame.Medium).length;
        const long = props.pairs.filter((p) => p.rating.timeFrame === TimeFrame.Long).length;
        return buildSegments([
            { label: 'Short', count: short, className: styles.bar_time_short },
            { label: 'Medium', count: medium, className: styles.bar_time_medium },
            { label: 'Long', count: long, className: styles.bar_time_long },
        ]);
    }, [props.pairs]);

    if (total === 0) {
        return null;
    }

    const renderBar = (label: string, segments: ISegmentData[]) => (
        <div className={styles.impact_bar_row}>
            <span className={styles.impact_bar_label}>{label}</span>
            <div className={styles.impact_bar}>
                {segments.map((seg) => (
                    <div
                        key={seg.label}
                        className={`${styles.impact_bar_segment} ${seg.className}`}
                        style={{ flex: seg.count }}
                        title={`${seg.label}: ${seg.count}`}
                    />
                ))}
            </div>
        </div>
    );

    return (
        <div className={styles.impact_bars_container}>
            {renderBar('Region', geoSegments)}
            {renderBar('Horizon', timeSegments)}
        </div>
    );
};

export default ImpactBars;
